import { userHasLevel } from "../../../engine/AuthRoute";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  renderUserName,
  renderUserNameEmail,
  roles,
  statusPrestations,
  statusPrestationsActual,
  statusPrestationsValues,
  subRoles,
  subRolesCheckbox,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import { EditFilled, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import React, { useContext, useState } from "react";
import Dayjs from "dayjs";
import dayjs, { tz } from "../../../utils/dayjs";
import { BiLinkExternal } from "react-icons/bi";
import { typesPrestation } from "../../../utils/typesPrestation";
import { Button, Space } from "antd";
import { IoAddSharp } from "react-icons/io5";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import routes from "../../../engine/routes";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";

export const prestationInputs = (
  prestation,
  formRef,
  change,
  setChange,
  user,
) => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
    applicationAt = null,
    category,
    institution,
    applicant,
    isSequentialPrestation,
  } = prestation;

  const context = useContext(ModalContext);

  let isDraft = prestation.status === statusPrestationsValues.draft;

  const setAdressByList = () => {
    let selected = formRef.current.getFieldValue("intervention.locationTo");

    const addresses = formRef.current["_intervention.locationTo"];

    let findAddress = addresses.find(e => e._id === selected);

    formRef.current.setFieldsValue({
      "intervention.location": findAddress.maps,
      "intervention.locationName": findAddress.location,
    });
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          placeholder: "Sera généré automatiquement",
          name: "reference",
          disabled: true,
          capitalize: false,
          type: "input",
          variant: "important",
          col: 24,
        },
        {
          label: "Institution du demandeur",
          disabled:
            !isDraft ||
            !userHasLevel({
              not: {
                [roles.institution]: "", //
              },
            }),
          name: "institution",
          value: userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          })
            ? institution?._id
            : user.institution,
          type: "dynamic-select",
          required: true,
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
        {
          // value: type,
          label: "Catégorie",
          name: "category",
          showSearch: true,
          value: category,
          watchRenderCondition: true,
          multiple: true,
          type: "select",
          selectContent: typesPrestation,
          selectType: "group",
          col: 24,
          watchDynamicObject: "institution",
          filterContent: (item, institution) => {
            if (institution?.mainType && institution?.mainType !== "") {
              return item.label === institution?.mainType;
            } else {
              return true;
            }
          },
        },
        {
          label: "Status",
          name: "status",
          disabled: true,
          type: "select",
          selectContent: statusPrestationsActual,
          col: 24,
        },
        {
          required: true,
          showSearch: true,
          disabled: !isDraft,
          label: "Langue de la prestation",
          name: "language",
          type: "select",
          selectContent: languagesList,
          col: 24,
        },
        {
          label: "Date de dépôt de la demande",
          quote: "Automatique lors de la confirmation de la commande",
          name: "applicationAt",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          value: applicationAt === null ? undefined : dayjs(applicationAt),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date",
          col: 24,
        },
        {
          required: true,
          label: "Date et heure de début",
          name: "intervention.startDate",
          value: dayjs(startDate),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                let newStartD = end.subtract(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.startDate": newStartD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date",
          col: 12,
        },
        {
          required: true,
          label: "Date et heure de fin",
          name: "intervention.endDate",
          value: dayjs(endDate),
          suffixIcon: <AiFillCalendar />,
          watch: "intervention.startDate",
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date",
          col: 12,
        },
      ],
    },
    {
      parentLabel: "Type d'intervention",
      children: [
        {
          label: "Type d'intervention",
          name: "intervention.type",
          required: true,
          type: "radios",
          radios: modeInterpretariat,
          col: 24,
        },
        {
          label: "Numéro de téléphone pour l'intervention",
          name: "intervention.phone",
          type: "input",
          required: true,
          watch: "intervention.type",
          addonBefore: "+41",
          watchRenderCondition: true,
          watchValues: [typeIntervention.phone],
          col: 24,
        },
        {
          label: "Lien pour la visio-conférence",
          name: "intervention.linkVisio",
          type: "input",
          required: true,
          watch: "intervention.type",
          addonBefore: <BiLinkExternal />,
          watchRenderCondition: true,
          watchValues: [typeIntervention.visio],
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Lieu de l'intervention",
      children: [
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <Space direction={"horizontal"}>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionSelectAddress,
                      {
                        institution: instituionId,
                        formRef,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  icon={
                    <LuMapPin
                      style={{
                        marginTop: "0px",
                      }}
                      size={15}
                    />
                  }
                  size={"small"}
                >
                  Sélectionner un lieu d'intervention prédéfini
                </Button>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionNewAddress,
                      {
                        institution: instituionId,
                        principal: null,
                        type: typeAddress.maps,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  size={"small"}
                  style={{
                    justifySelf: "flex-start",
                    display: "flex",
                  }}
                  icon={
                    <IoAddSharp
                      style={{
                        marginTop: "0px",
                      }}
                      size={25}
                    />
                  }
                >
                  Ajouter un lieu d'intervention
                </Button>
              </Space>
            );
          },
          col: 24,
        },
        {
          label: "Lieu de l'intervention (Institution)",
          name: "intervention.locationName",
          disabled: true,
          // required: true,
          type: "input",
          watchRequiredCondition: true,
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          col: 24,
        },
        {
          // required: true,
          label: "Adresse d'intervention",
          disabled: true,
          name: "intervention.location",
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          watchRequiredCondition: true,
          watchValuesCallback: (value, form, r) => {},
          value: prestation.intervention.location,
          type: "google-adress",
          col: 24,
          // watchDynamicObject: "institution",
          // watchDynamicSetEmpty: true,
          // watchRenderCondition: true,
          // watchDynamicSetter: institution => institution?.interventionLocation,
        },
        {
          visible:
            userHasLevel({
              only: {
                [roles.admin]: "crud", //
              },
            }) && [statusPrestationsValues.planned].includes(prestation.status),
          label: "Lieu de départ de l'interprète",
          name: "intervention.locationFrom",
          value: prestation.intervention.locationFrom,
          type: "google-adress",
          col: 24,
        },
        {
          label:
            "Complément du lieu de l'intervention (Étage, Salle, Digicode)",
          name: "intervention.extra",
          type: "input",
          watch: "intervention.type",
          watchValues: [
            typeIntervention.visio,
            typeIntervention.in_person,
            typeIntervention.phone,
          ],
          col: 24,
        },
        {
          label: "Ceci est une prestation à la suite",
          description: (
            <span>
              Cette prestation pourra être facturée moins d’une heure, mais au
              minimum : 1) la durée commandée et 2) la durée effective. <br />
              <br />
              Cette prestation doit faire partie d’une suite de prestations
              d’une durée totale d’au moins 1 heure (yc précédentes et
              suivantes). Si ce n’est pas le cas, faites en sorte que la durée
              totale fasse au moins 1 heure. Remarque : Si plus de 60 min
              d’attente sont planifiées entre deux prestations, veuillez ne pas
              les considérer comme une suite.
            </span>
          ),
          name: "isSequentialPrestation",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: isSequentialPrestation,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Critères de l'interprète ",
      children: [
        {
          required: true,
          label: "Genre de l'interprète",
          name: "search.searchGenre",
          type: "select",
          multiple: true,
          selectContent: [
            { label: "Femme", value: "female" },
            { label: "Homme", value: "male" },
          ],
          col: 24,
        },
        {
          required: true,
          label: "Niveau de l'interprète",
          name: "search.searchLevel",
          type: "select",
          multiple: true,
          selectContent: levels,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Informations demandeur",
      children: [
        {
          label: "Demandeur",
          //  disabled: !isDraft,
          name: "applicant",
          required: true,
          value: applicant?._id,
          type: "dynamic-select",
          endPoint: institution =>
            `/users?subRole=${subRoles.institutionDemander}&institution=${institution}`,
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          watchDynamicSetEmpty: true,
          updateEndPoint: [change],
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserNameEmail(item),
              value: item._id,
            };
          },
          col: 24,
        },
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <>
                <CreateApplicant
                  disabled={disabled}
                  key={Math.random()}
                  name={"applicant"}
                  formRef={formRef}
                  onCreated={_id => {
                    setChange(_id);
                  }}
                />
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: "Sauvegarder & suivant",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
